import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Link } from 'react-router-dom';
import { updateActiveAttendee } from 'common/slice/selectedAttendeeSlice';
import { removeBreadcrumb } from 'common/slice/breadcrumbsSlice';

const Header = () => {
  const dispatch = useAppDispatch();
  const breadcrumbs = useAppSelector((state) => state.breadcrumbs);
  const activeAttendee = useAppSelector((state) => state.selectedAttendee);
  const handleOnClik = () => {
    dispatch(updateActiveAttendee({ ...activeAttendee, isDetailView: false }));
    dispatch(removeBreadcrumb());
  };

  return (
    <nav className="flex flex-row h-10 justify-between items-center p-2 bg-white border-b-2 border-gray-200">
      <ol className="list-reset flex text-gray-700">
        {breadcrumbs.map((crumb, index) => (
          <li key={index}>
            {crumb.url ? (
              <Link
                to={crumb.url}
                onClick={handleOnClik}
                className="underline"
                data-testid={`breadcrumb-link-${index}`}
              >
                {crumb.label}
              </Link>
            ) : (
              <span>{crumb.label}</span>
            )}
            {index < breadcrumbs.length - 1 && <span className="mx-2">/</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Header;
